import React from 'react';
import { motion } from 'framer-motion';
import { RotateCcw, Home, Trophy, Target, Zap } from 'lucide-react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { GameStats, GameMode } from '../types';
interface ResultsProps {
  stats: GameStats;
  mode: GameMode;
  onRestart: () => void;
  onHome: () => void;
}
export function Results({
  stats,
  mode,
  onRestart,
  onHome
}: ResultsProps) {
  const accuracy = Math.round(stats.correct / stats.total * 100) || 0;
  const timeInSeconds = stats.endTime && stats.startTime ? (stats.endTime - stats.startTime) / 1000 : 0;
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="w-full max-w-md mx-auto p-4 space-y-8" data-id="element-199">
      <div className="text-center" data-id="element-200">
        <motion.div initial={{
        scale: 0.5,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} className="inline-flex items-center justify-center w-20 h-20 bg-yellow-100 text-yellow-600 rounded-full mb-4" data-id="element-201">
          <Trophy className="w-10 h-10" data-id="element-202" />
        </motion.div>
        <h2 className="text-3xl font-bold text-slate-900" data-id="element-203">Session Complete!</h2>
        <p className="text-slate-500 mt-2" data-id="element-204">Here's how you did</p>
      </div>

      <Card className="p-6 space-y-6" data-id="element-205">
        <div className="grid grid-cols-2 gap-4" data-id="element-206">
          <div className="bg-slate-50 p-4 rounded-xl text-center" data-id="element-207">
            <div className="text-slate-500 text-sm font-medium mb-1 flex items-center justify-center gap-1" data-id="element-208">
              <Target className="w-4 h-4" data-id="element-209" /> Accuracy
            </div>
            <div className="text-2xl font-bold text-slate-900" data-id="element-210">{accuracy}%</div>
            <div className="text-xs text-slate-400" data-id="element-211">
              {stats.correct}/{stats.total} Correct
            </div>
          </div>

          <div className="bg-slate-50 p-4 rounded-xl text-center" data-id="element-212">
            <div className="text-slate-500 text-sm font-medium mb-1 flex items-center justify-center gap-1" data-id="element-213">
              <Zap className="w-4 h-4" data-id="element-214" /> Best Streak
            </div>
            <div className="text-2xl font-bold text-slate-900" data-id="element-215">
              {stats.bestStreak}
            </div>
          </div>
        </div>

        {mode === 'set_count' && <div className="bg-indigo-50 p-6 rounded-xl text-center border border-indigo-100" data-id="element-216">
            <div className="text-indigo-600 text-sm font-medium mb-2 uppercase tracking-wider" data-id="element-217">
              Total Time
            </div>
            <div className="text-4xl font-bold text-indigo-900" data-id="element-218">
              {formatTime(timeInSeconds)}
            </div>
          </div>}

        <div className="space-y-3 pt-4" data-id="element-219">
          <Button onClick={onRestart} fullWidth size="lg" data-id="element-220">
            <RotateCcw className="w-5 h-5 mr-2" data-id="element-221" /> Play Again
          </Button>
          <Button onClick={onHome} variant="ghost" fullWidth data-id="element-222">
            <Home className="w-5 h-5 mr-2" data-id="element-223" /> Back to Menu
          </Button>
        </div>
      </Card>
    </div>;
}